import { ApolloLink } from '@apollo/client';

// There is an issue with apollo-upload-client types that requires us to use 'as unknown as ApolloLink'
// - see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/47369
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { createUploadLink } from 'apollo-upload-client';

let terminatingLink: ApolloLink;

// There is an issue with apollo-upload-client types that requires us to use 'as unknown as ApolloLink'
// - see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/47369
if (!process.env.GRAPHQL_ENDPOINT) {
  terminatingLink = createUploadLink({ uri: '/sq-gql' }) as unknown as ApolloLink;
} else {
  terminatingLink = createUploadLink({ uri: process.env.GRAPHQL_ENDPOINT }) as unknown as ApolloLink;
}

export { terminatingLink };
